import type { UseDataReturn } from "~/hooks/useData";
import useData from "~/hooks/useData";
import useCurrentUser from "~/hooks/user/useCurrentUser";
import type { Organization } from "~/types/collections";

/**
 * Hook to fetch single organization data.
 * It first fetches the current user's data to get the organization ID,
 * then fetches the organization data using that ID.
 * @returns {UseDataReturn<Organization>} The organization data and loading state.
 */
const useSingleOrganization = (): UseDataReturn<Organization> => {
  const {
    data: { organization },
    isLoading: userLoading,
  } = useCurrentUser();

  const organizationId = organization?.id;

  return useData<Organization>({
    serialLoading: userLoading,
    collection: "organizations",
    id: organizationId,
    depth: 2,
  });
};

export default useSingleOrganization;
